// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","314":"e7fc1196","513":"f3a73f1d","551":"c640c579","706":"cc727622"}[chunkId] + ".chunk.js";
};